import { AutoComplete, Row, Col, Tooltip } from "antd"
import { SearchBar } from "../../atoms/SearchBar/index"
import React from "react"
import { connect } from "react-redux"
import { setChatSpaceName } from "../../redux/actionCreators/chatData"
import { withRouter } from "react-router-dom"
import "./AddressModel.scss"
import {
  SAVE_BUTTON,
  CHANGE_ADDRESS_TITLE,
  ADDRESS_PLACEHOLDER,
  PARTNER_UPDATED_ADDRESS_CONTENT,
  CANCEL,
  CHANGE_ADDRESS_CONTENT,
  PARTNER_UPDATED_ADDRESS_HEADING,
} from "../../constants/messages"
import { EditFilled, LoadingOutlined } from "@ant-design/icons"
import {
  updateAddress,
  fetchAddressAutoComplete,
  setSavingAddress,
} from "../../redux/actionCreators/auth"
import Text from "antd/lib/typography/Text"
import { TextTag, CustomModal, Button } from "../../atoms"
import { FIREBASE_STATE_KEYS, FirebaseService } from "../../firebase"
import BlockingModal from "../BlockingModal/BlockingModal"
import {
  getRestaurants,
  validateUserAddress,
} from "../../redux/actionCreators/planDinnner"
import _ from "../../utils/lodashUtils"
import LocationIcon from "../../assets/images/Location.svg"
import { getPartnerNameorNickName } from "../../utils/helpers"

class AddressModal extends React.Component {
  state = {
    visible: false,
    address: this.props.address,
    addressOptions: [],
    notifyModalVisibility: false,
    addressError: "",
  }

  showModal = () => {
    this.setState({
      visible: true,
    })
  }

  handleOk = e => {
    this.setState({
      visible: false,
    })
  }

  handleCancel = e => {
    this.setState({
      ...this.state,
      address: this.props.address,
      visible: false,
      addressError: "",
    })
  }
  handleSearch = async value => {
    this.setState({
      ...this.state,
      address: value,
      addressError: "",
    })
    if (value) {
      //get address from backend(gcp) on change
      let addresses = await this.props.fetchAddressAutoComplete(value)
      this.setState({
        ...this.state,
        addressOptions: addresses.data,
      })
    }
  }

  onSelect = value => {
    this.setState({
      ...this.state,
      address: value,
      addressError: "",
    })
  }

  getChildren = () =>
    this.state.addressOptions.map(address => (
      <AutoComplete.Option key={address.id} value={address.description}>
        {address.description}
      </AutoComplete.Option>
    ))

  componentWillReceiveProps(nextProps) {
    const { partnerState, userState } = nextProps
    const activeScreen = _.get(userState, "activeScreen")
    //show modal to partner when user changes address
    if (
      this.props.partnerState &&
      partnerState &&
      userState &&
      _.get(this.props, "userState.userDetails.address") &&
      _.get(this.props, "partnerState.userDetails.address") &&
      _.get(this.props, "partnerState.userDetails.address.user_address") !==
        _.get(partnerState, "userDetails.address.user_address") &&
      activeScreen === "SELECT_RESTAURANT"
    ) {
      this.setState({
        notifyModalVisibility: true,
      })
    }
    //get common restaurants when address change
    if (
      this.props.userState &&
      userState &&
      _.get(this.props, "userState.userDetails.address.user_address") !==
        _.get(userState, "userDetails.address.user_address")
    ) {
      this.props.getRestaurants()
    }
  }

  render() {
    const { partnerState, userState, dateState } = this.props
    const userAddress = _.get(userState, "userDetails.address.user_address")
    const activeScreen = _.get(userState, "activeScreen")
    const resetRestaurantSuggestion = _.get(
      dateState,
      `${FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT}.${FIREBASE_STATE_KEYS.RESET_RESTAURANT}`
    )
    const acceptedRestaurant = _.get(
      dateState,
      FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT
    )
    const partnerName = getPartnerNameorNickName(partnerState)
    let partnerGender = ""
    partnerGender =
      _.get(partnerState, "userDetails.gender") === "MALE"
        ? " his"
        : _.get(partnerState, "userDetails.gender") === "FEMALE"
        ? " her"
        : " their"
    return (
      <div>
        <div className="reverse-row">
          {dateState && userState && _.get(userState, "userDetails.address") && (
            <Tooltip title={userAddress}>
              <TextTag textType="smallTextSecondary" className="address-bar">
                {!_.isEmpty(userAddress) ? userAddress : null}{" "}
                {userState &&
                  _.get(userState, "userDetails.address") &&
                  dateState &&
                  (activeScreen === "SELECT_RESTAURANT" ||
                    resetRestaurantSuggestion ||
                    !acceptedRestaurant) && (
                    <EditFilled
                      style={{ color: "#ffffff" }}
                      onClick={this.showModal}
                    />
                  )}
              </TextTag>
            </Tooltip>
          )}
          <div>
            {dateState &&
              userState &&
              _.get(userState, "userDetails.address") && (
                <img
                  className="location-icon"
                  src={LocationIcon}
                  alt="location"
                />
              )}
          </div>
        </div>
        <BlockingModal
          title={PARTNER_UPDATED_ADDRESS_HEADING(partnerName, partnerGender)}
          content={PARTNER_UPDATED_ADDRESS_CONTENT}
          blockingModalVisibility={this.state.notifyModalVisibility}
          continueHandler={() => {
            this.setState({
              notifyModalVisibility: false,
            })
            this.props.getRestaurants()
          }}
        />
        <CustomModal
          title={CHANGE_ADDRESS_TITLE}
          visible={this.state.visible}
          keyboard={false}
          onCancel={this.handleCancel}
          footer={[
            <Button
              key="save"
              className="save-btn"
              disabled={!this.state.address || this.props.savingAddress}
              onClick={() => {
                if (this.state.address) {
                  this.props.setSavingAddress(true)
                  //validate address if its as per delivery.com standard with street address etc.
                  this.props
                    .validateUserAddress(this.state.address, "", () => {
                      this.props.updateAddress(this.state.address, false)
                      this.props.getRestaurants()
                      this.handleOk()
                    })
                    .then(response => {
                      if (_.get(response, "status") === 400)
                        this.setState({ addressError: response.data.error })
                    })

                  //delete previously suggested restaurant when address changes
                  FirebaseService.delete(
                    `${FirebaseService.getDefaultPath()}${_.get(
                      userState,
                      "userDetails.uuid"
                    )}/${FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT}`
                  )

                  FirebaseService.delete(
                    `${FirebaseService.getDefaultPath()}${_.get(
                      partnerState,
                      "userDetails.uuid"
                    )}/${FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT}`
                  )
                }
              }}
            >
              {this.props.savingAddress && <LoadingOutlined />}
              {SAVE_BUTTON}
            </Button>,
            <Button key="cancel" btnType="bordered" onClick={this.handleCancel}>
              {CANCEL}
            </Button>,
          ]}
        >
          <div>
            <Row id="HeaderRow">
              <Col className="address-modal-content">
                <Text className="modal-content-text" textType="sectionHeading">
                  {CHANGE_ADDRESS_CONTENT(partnerName)}
                </Text>
                <SearchBar
                  style={{
                    width: "100%",
                    marginTop: "1em",
                  }}
                  placeholder={ADDRESS_PLACEHOLDER}
                  className="search-bar"
                  value={this.state.address}
                  onSearch={this.handleSearch}
                  onSelect={this.onSelect}
                  allowClear={true}
                >
                  {this.state.address ? this.getChildren() : null}
                </SearchBar>
                {this.state.addressError && (
                  <div className="address-error">{this.state.addressError}</div>
                )}
              </Col>
            </Row>
          </div>
        </CustomModal>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    savingAddress: _.get(state, "loadingState.savingAddress"),
  }
}

export default connect(mapStateToProps, {
  setChatSpaceName,
  updateAddress,
  validateUserAddress,
  setSavingAddress,
  fetchAddressAutoComplete,
  getRestaurants,
})(withRouter(AddressModal))
